export function GetTemplateHeader(event: JQuery.TriggeredEvent) {
    const templateId: number = $(event.currentTarget).data('template-id');

    $.ajax({
        url: window.ETDR_RD.appConfig["UrlAction.GetTemplateHeader"],
        data: {id: templateId},
        type: 'GET',
        xhrFields: {
            responseType: 'blob'
        },
        success: (data) => {
            openFile(data, templateId);
        }
    });
}

function openFile(data: any, templateId: number) {
    const blob: Blob = new Blob([data], { type: 'image/jpeg' });
    const url: string = window.URL.createObjectURL(blob);
    let anchorElem: HTMLAnchorElement = createAnchorElement(templateId, url);

    anchorElem.click();

    window.URL.revokeObjectURL(url);
}

function createAnchorElement(templateId: number, url: string): HTMLAnchorElement {
    let result: HTMLAnchorElement = document.createElement('a');
    result.style.display = 'none';
    result.href = url;
    result.target = '_blank';
    document.body.appendChild(result);
    result.download = `headerTemplate_${templateId}.jpg`;

    return result;
}

$(document).on('click', '#headerDownloadBtn', (event) => {
    GetTemplateHeader(event);
});
